import { saveToken, startRefreshingToken, doneRefreshingToken  } from '../modules/auth.js';
import { logout } from '../modules/user.js';
import { encodeDataToForm, clearAuthToken, tokenValid, getApiBase } from '../../api/utilities/utilities';

export function jwt({ dispatch, getState }) {
    return next => action => {
        // only worry about expiring token for async actions
        if (typeof action === 'function') {
            if (getState().auth && getState().auth.token) {
                const accessExpires = getState().auth.token.accessExpires;

                if (tokenValid(accessExpires) === false) {
                    const refreshExpires = getState().auth.token.refreshExpires;
                    if (tokenValid(refreshExpires) === false) {
                        // handle expired token (kick the user back out to login)
                        dispatch(logout());
                        return handleExpiredRefreshToken(dispatch, getState().auth.authFailFn);
                    } else {
                        // make sure we are not already refreshing the token
                        if (getState().auth.freshTokenPromise === null) {
                            return refreshToken(dispatch, getState().auth.token.refreshToken).then(() => next(action));
                        } else {
                            return getState().auth.freshTokenPromise.then(() => next(action));
                        }
                    }
                }
            }
        }
        return next(action);
    };
}

function handleExpiredRefreshToken(dispatch, failFn) {
    let token = null
    clearAuthToken();
    dispatch(doneRefreshingToken());
    dispatch(saveToken(token))
    failFn();
    return Promise.resolve();
}

function fetchJWTToken(refreshToken) {
    return fetch(getApiBase() + '/refresh', {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        method: 'POST',
        body: encodeDataToForm({ refresh_token: refreshToken })
    })
        .then((response) => response.json())
        .then((response) => response)
        .catch((error) => {
            console.error(error);
        });
}

function refreshToken(dispatch, refreshToken) {
    const freshTokenPromise = fetchJWTToken(refreshToken)
        .then(t => {
            dispatch(doneRefreshingToken());
            dispatch(saveToken(t.token))

            return t.token ? Promise.resolve(t.token) : Promise.reject({
                message: 'could not refresh token'
            });
        })
        .catch(e => {
            console.log('error refreshing token', e);
            dispatch(doneRefreshingToken());
            return Promise.reject(e);
        });

    // This set the store to equal the refresh token until it has been overwritten 
    // we want to keep track of token promise in the state so that we don't try to refresh
    // the token again while refreshing is in process
    dispatch(startRefreshingToken(freshTokenPromise));

    return freshTokenPromise;
}



// WEBPACK FOOTER //
// ./src/redux-modules/middleware/jwtMiddleware.js